import { ResetPasswordService } from '@/common/services/reset-password.service';
import * as Routes from '@/router/routes';
import router from '@/router';

export const ResetPasswordModule = {
    actions: {
        async createResetToken(context, email) {
            try {
                context.dispatch('showSpinner');
                await ResetPasswordService.createResetToken(email);
                context.dispatch('createSuccessNotification', 'If account exists, an email will be sent with further instructions');
            } finally {
                context.dispatch('hideSpinner');
            }
        },

        async resetPassword(context, payload) {
            try {
                context.dispatch('showSpinner');
                await ResetPasswordService.resetPassword(payload);
                router.push({ name: Routes.LOGIN });
                context.dispatch('createSuccessNotification', 'Password has been changed');
            } finally {
                context.dispatch('hideSpinner');
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/reset-password/reset-password.module.js